// src/app/builderio/custom-components/StaticMap/StaticMap.tsx
import React from 'react';
import { BuilderComponent } from '@builder.io/react';

interface StaticMapProps {
  latitude: number;
  longitude: number;
  width: number;
  height: number;
}

const StaticMap: React.FC<StaticMapProps> = ({ latitude, longitude, width, height }) => {
  const markerImage = `${(process.env.REACT_APP_WEB_URL ?? "").replace(/^https:\/\//, 'http://')}/${process.env.REACT_APP_SUBDIRECTORY}/assets/pin-blue-small.png`;
  const marker = `icon:${encodeURIComponent(markerImage)}|${latitude},${longitude}`;
  
  const staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap?scale=2&center=${latitude},${longitude}&zoom=10&size=${width}x${height}&markers=${marker}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? ""}`;

  return (
    <div style={{ width: '100%', height: '100%', backgroundColor: 'lightgray' }}>
      <img
        src={staticMapUrl}
        alt="Map"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />
    </div>
  );
};

export const staticMapRegistration = {
    name: "Static Map",
    inputs: [
        {
            name: "latitude",
            type: "number",
        },
        {
            name: "longitude", 
            type: "number",
        },
        {
            name: "width",
            type: "number",
        },
        {
            name: "height",
            type: "number",
        }
    ],
    image: 'https://st4.depositphotos.com/18657574/21818/v/450/depositphotos_218186000-stock-illustration-map-icon-trendy-design-style.jpg',
    description: 'Add a static map component to the page'
}

export default StaticMap;